module.exports = "{{localize 'CORE.GRID.LOADINGROW.LOADING'}}";


//////////////////
// WEBPACK FOOTER
// ../src/list/templates/loadingRow.hbs
// module id = 709
// module chunks = 0